import React, { useState, useEffect } from 'react'
// import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Pagination from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'
import IconButton from '@mui/material/IconButton'
import SettingsIcon from '@mui/icons-material/Settings'
// import AddCircleIcon from '@mui/icons-material/AddCircle'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import defaultTexts from '../../texts/texts'
import constants from '../../config/constants'
import useWindowDimensions from '../_common/WindowDimesnions'
import { request } from '../../_network/request'
import { alertsURLs } from '../../_network/apiUrls'
import CustomDialog from '../_common/CustomDialog'
import CustomBackdrop from '../_common/CustomBackdrop'
import CustomBreadMenu from '../_common/CustomBreadMenu'
import NotificationSettings from './NotificationSettings'
import NotificationAdd from './NotificationAdd'
import NotificationItem from './NotificationItem'

const NotificationsWrapper = (props) => {
  const theme = useTheme()
  const location = useLocation()
  const navigate = useNavigate()
  const { width } = useWindowDimensions()

  // const user_role = useSelector(state => state.profile.user_role)
  // const editPermission = user_role === 'superadmin' || user_role === 'owner' || user_role === 'admin'

  const [activeTab, setActiveTab] = useState('core')
  const [settingsDialogOpen, setSettingsDialogOpen] = useState(false)
  const [notificationAddDialogOpen, setNotificationAddDialogOpen] = useState(false)
  const [notificationSentDialogOpen, setNotificationSentDialogOpen] = useState(false)
  const [alerts, setAlerts] = useState([])
  const [fetchAlerts, setFetchAlerts] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [isLoading, setIsLoading] = useState(false)

  const breadMenu = [
    {
      value: 'core',
      label: defaultTexts.accountNotifications,
    },
    {
      value: 'openstack_admin',
      label: defaultTexts.openStackSolutionKit,
    },
  ]

  const pageLabelStyle = {
    color: theme.palette.vodka,
    fontSize: '18px',
    fontWeight: '500',
    padding: '0px 0px 20px 20px',
  }

  const wrapperStyle = {
    background: theme.palette.aliceBlue,
    borderRadius: width >= constants.mdBreakpoint ? '0px 20px 20px 20px' : '0px 0px 20px 20px',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    padding: '20px',
    minHeight: '500px',    
  }

  const flexWrapperStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }

  const paginationButtonStyle = {
    fontWeight: '500',
    color: theme.palette.violetsAreBlue,
    borderColor: theme.palette.violetsAreBlue,
  }

  const noAlertsNotificationStyle = {
    fontSize: '24px',
    textAlign: 'center',
    padding: '20px 0px',
  }

  const handleChangeActiveTab = (value) => {
    setActiveTab(value)
  }

  const handleSettingsDialogOpen = () => {
    setSettingsDialogOpen(true)
  }

  const handleSettingsDialogClose = () => {
    setSettingsDialogOpen(false)
  }

  // const handleNotificationAddDialogOpen = () => {
  //   setNotificationAddDialogOpen(true)
  // }

  const handleNotificationAddDialogClose = () => {
    setNotificationAddDialogOpen(false)
  }

  const handleNotificationSentDialogOpen = () => {
    setNotificationSentDialogOpen(true)
  }

  const handleNotificationSentDialogClose = () => {
    setNotificationSentDialogOpen(false)
  }

  const handleChangeCurrentPage = (event, value) => {
    setCurrentPage(value)
  }
  
  const handleDeleteNotification = async (id) => {
    setIsLoading(true)

    const url = constants.core_service_domain + '/' + alertsURLs.getAlerts + '/' + id
    const request_data = { url, method: 'DELETE' }
    await request(request_data)

    setIsLoading(false)
    setFetchAlerts(prev => prev + 1)
  }

  useEffect(() => {
    if (location && location.state && location.state.group) {
      setActiveTab(location.state.group)
      navigate(location.pathname)
    }
  }, [location, navigate])

  useEffect(() => {
    const fetchAlertsData = async () => {
      setIsLoading(true)

      const url = constants.core_service_domain + '/' + alertsURLs.getAlerts + '?group=' + activeTab
      
      const request_data = { url, method: 'GET' }
      
      const response = await request(request_data)
      
      if (response.status_code && response.status_code < 400 && response.data && response.data.length > 0) {
        setTotalPages(Math.ceil(response.data.length/constants.notifications_limit))
        setAlerts(response.data.filter((item, index) => index >= (currentPage - 1) * constants.notifications_limit && index < currentPage * constants.notifications_limit))
      } else {
        setTotalPages(1)
        setAlerts([])
      }

      setIsLoading(false)
    }

    fetchAlertsData()
  }, [activeTab, currentPage, fetchAlerts])
  
  return (
    <>
      { isLoading && <CustomBackdrop open={isLoading} /> }

      <Box sx={{ padding: '40px 20px' }}>

        <Stack
          direction='row'
          alignItems='flex-start'
          justifyContent='space-between'
        >
          <Box sx={pageLabelStyle}>{defaultTexts.notifications}</Box>
          <Box>
            <Stack
              direction='row'
              alignItems='flex-start'
              justifyContent='flex-end'
              spacing={1}
            >
              {/* {
                editPermission &&
                <IconButton
                  onClick={handleNotificationAddDialogOpen}
                  sx={{ color: theme.palette.greenSheen }}
                >
                  <AddCircleIcon fontSize='large' />
                </IconButton>
              } */}

              <IconButton
                onClick={handleSettingsDialogOpen}
                sx={{ color: 'black' }}
              >
                <SettingsIcon fontSize='large' />
              </IconButton>
            </Stack>
          </Box>          
        </Stack>

        <CustomBreadMenu
          breadMenu={breadMenu}
          activeTab={activeTab}
          handleChangeActiveTab={handleChangeActiveTab}
        />

        <Box sx={ alerts.length > 0 ? wrapperStyle : { ...wrapperStyle, ...flexWrapperStyle } }>
          {
            alerts.length > 0 ?
            <>
              {
                alerts.map((item, index) => (
                  <NotificationItem
                    key={index}
                    {...item}
                    handleDeleteNotification={handleDeleteNotification}
                  />
                ))
              }
            </> :
            <Box sx={noAlertsNotificationStyle}>{defaultTexts.noNotifications}</Box>
          }          

          {
            totalPages > 1 &&
            <Stack
              alignItems='center'
              justifyContent='center'
              sx={{ marginTop: '40px' }}
            >
              <Pagination
                variant='outlined'
                count={totalPages}
                page={currentPage}
                boundaryCount={2}
                onChange={handleChangeCurrentPage}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{
                      previous: ArrowBackIcon,
                      next: ArrowForwardIcon,
                      }}
                    sx={paginationButtonStyle}
                    {...item}
                  />
                )}
              />
            </Stack>
          }
        </Box>

      </Box>

      <CustomDialog
        open={settingsDialogOpen}
        onClose={handleSettingsDialogClose}
        dialogTitle={{
          title: defaultTexts.emailNotificationsSettings,
          sx: {
            color: theme.palette.violetsAreBlue,
            fontSize: '22px',
            fontWeight: '500',
          },
        }}
        closeIconColor={theme.palette.violetsAreBlue}
        maxWidth='md'
			>
        <NotificationSettings />
      </CustomDialog>

      <CustomDialog
        open={notificationAddDialogOpen}
        onClose={handleNotificationAddDialogClose}
        dialogTitle={{
          title: defaultTexts.newNotification,
          sx: {
            color: theme.palette.violetsAreBlue,
            fontSize: '22px',
            fontWeight: '500',
          },
        }}
        closeIconColor={theme.palette.violetsAreBlue}
			>
        <NotificationAdd
          setFetchAlerts={setFetchAlerts}
          handleNotificationAddDialogClose={handleNotificationAddDialogClose}
          handleNotificationSentDialogOpen={handleNotificationSentDialogOpen}
        />
      </CustomDialog>

      <CustomDialog
        open={notificationSentDialogOpen}
        onClose={handleNotificationSentDialogClose}
        dialogTitle={{ title: defaultTexts.newNotification }}
        dialogBody={{
          text: defaultTexts.notificationHasBeenSent,
          sx: { paddingBottom: '20px' }
        }}
      />
    </>
  )
}

export default NotificationsWrapper